import createCustomInStreamAd from './createCustomInStreamAd';

export default createCustomInStreamAd();
